import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
// import classNames from 'classnames';
import messages from './onlineSimulatedMessages';
import './OnlineSimulatedCard.scss';

function OnlineSimulatedCard(props) {
  const { formatMessage } = props.intl;
  const isDisabled =
    props.status === 'applied' ||
    props.status === 'expired' ||
    props.status === 'scheduled';

  return (
    <div className="card card-school online-simulated-card" style={props.style}>
      <div
        className="card-body"
        onClick={isDisabled ? undefined : props.onClick}
        style={{ cursor: isDisabled ? 'default' : 'pointer' }}
      >
        <div className="card-id">ID: {props.code}</div>
        {/* <div className="fixed-actions">
          <button className="edit-card" onClick={props.onClick}>
            <i className="ti-pencil-alt" />
            {formatMessage(messages.edit)}
          </button> 
        </div> */}
        <h5 className="card-title my-0 mt-5 mb-2" style={{ color: '#F59F8D' }}>
          <span>{props.application}</span>
          <span> {props.applicationDisciplines}</span>
        </h5>
        <p className="mb-2 text-gray">{props.courseName}</p>
        <p className="mb-2 text-gray">{props.abbreviationsDisciplines}</p>
        {props.status && (props.status === 'ongoing' || props.status === 'available') && (
          <div className="badge badge-info badge-status">
            {props.status === 'available' && formatMessage(messages.available)}
            {props.status === 'ongoing' && formatMessage(messages.ongoing)}
          </div>
        )}
        {props.status && props.status === 'scheduled' ? (
          <span className="badge badge-warning">{formatMessage(messages.scheduled)}</span>
        ) : (
          props.status &&
         ( props.status === 'applied' ||
          props.status === 'expired') && (
            <span className="badge badge-success">
              {props.status === 'applied' && formatMessage(messages.applied)}
              {props.status === 'expired' && formatMessage(messages.expired)}
            </span>
          )
        )}
        <div className="mt-5">
          {props.status && (props.status === 'ongoing' || props.status === 'available') && (
            <button
              className="btn btn-sm btn-start"
              // style={{ bottom: '40px' }}
              onClick={props.onClick}
              type="button"
            >
              {props.status === 'ongoing'
                ? formatMessage(messages.continue)
                : formatMessage(messages.start)}
            </button>
          )}
        </div>
      </div>
      <div>
        <div className="cm-date">
          {moment(props.dateStart).format('DD/MM/YYYY')} {formatMessage(messages.at)}{' '}
          {props.timeStart} {formatMessage(messages.until)}{' '}
          {moment(props.dateEnd).format('DD/MM/YYYY')} {formatMessage(messages.at)} {props.timeEnd}
          {props.duration &&
            ` ${formatMessage(messages.withDuration)} ${props.duration.slice(0, 5)}`}
        </div>
      </div>
    </div>
  );
}

OnlineSimulatedCard.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func,
  iconClassName: PropTypes.string,
  // title: PropTypes.string,
  // period: PropTypes.string,
  dateStart: PropTypes.oneOf(PropTypes.string, PropTypes.date),
  // amountStudents: PropTypes.number,
  // amountCards: PropTypes.number,
  // badge: PropTypes.node,
  intl: PropTypes.object,
};

OnlineSimulatedCard.defaultProps = {
  iconClassName: 'pe-7s-light',
  dateStatus: {},
};

export default injectIntl(OnlineSimulatedCard);
